import React, { useEffect, useMemo, useState } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import MyPagesMobileMenu from './MyPagesMobileMenu';
import MyPagesDesktopMenu from './MyPagesDesktopMenu';
import MyPagesSettings from './MyPagesSettings';
import MyPagesOrderHistory from './MyPagesOrderHistory';
import MyPagesOrderDetail from './MyPagesOrderDetail';
import MyPagesUsers from './MyPagesUsers';
import MyPagesAddUser from './MyPagesAddUser';
import MyPagesEditUser from './MyPagesEditUser';
import MyPagesAddresses from './MyPagesAddresses';
import MyPagesAddAddress from './MyPagesAddAddress';
import MyPagesEditAddress from './MyPagesEditAddress';
import { translate } from '../../Services/translation';
import ScrollToTop from './ui/ScrollToTop';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import MyPagesInvoices from './Invoices/MyPagesInvoices';
import MyPagesPriceLabels from './MyPagesPriceLabels';
import MyPagesService from './MyPagesService';
import MyPagesOrderApprover from './MyPagesOrderApprover';
import MyPagesRma from './rma/MyPagesRma';
import MyPageInvoiceDetails from './Invoices/MyPagesInvoiceDetails';
import MyPagesImageStorage from './MyPagesImageStorage';
import clsx from 'clsx';

const navigation = [
  { name: translate('mypage.info.title'), url: '/', isB2bOnly: false },
  {
    name: translate('mypage.order.title'),
    url: '/orders',
    isB2bOnly: false,
  },
  {
    name: translate('mypage.person.title'),
    url: '/users',
    isB2bOnly: true,
  },
  {
    name: translate('mypage.address.addresses'),
    url: '/addresses',
    isB2bOnly: true,
  },
  {
    name: translate('mypage.invoices.title'),
    url: '/invoices',
    isB2bOnly: false,
  },
  {
    name: translate('mypage.image.storage.title'),
    url: '/imagestorage',
    isB2bOnly: true,
  },
  {
    name: translate('mypage.pricelabels.title'),
    url: '/pricelabels',
    isB2bOnly: false,
  },
  {
    name: translate('mypage.service.title'),
    url: '/service',
    isB2bOnly: false,
  },
  {
    name: translate('mypage.rma.title'),
    url: '/rma',
    isB2bOnly: false,
  },
  {
    name: translate('mypage.orderapprover.title'),
    url: '/orderapprover',
    isB2bOnly: false,
  },
];

const MyPagesContainer = (props) => {
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );
  const [ready, setReady] = useState(false);

  const filteredNav = useMemo(
    () =>
      navigation.filter((option) =>
        !userInfo?.isBusinessCustomer ? !option.isB2bOnly : true
      ),
    [userInfo?.isBusinessCustomer]
  );

  useEffect(() => {
    document.getElementById('my-pages-loading-spinner')?.remove();
    setReady(true);
  }, []);  

  return (
    <>
      <section
        className={clsx(
          'container min-h-[72vh] py-4 text-gray-900 lg:grid lg:grid-cols-4 lg:gap-12 lg:py-6',
          ready ? 'block' : 'hidden'
        )}
      >
        <HashRouter>
          <ScrollToTop />
          <MyPagesMobileMenu navigation={filteredNav} />
          <MyPagesDesktopMenu navigation={filteredNav} />
          <Routes>
            <Route path="/" element={<MyPagesSettings />} />
            <Route path="/orders" element={<MyPagesOrderHistory />} />
            <Route path="/orders/:id" element={<MyPagesOrderDetail />} />
            <Route path="/invoices" element={<MyPagesInvoices />} />      
            <Route
              path="/invoices/:id"
              element={<MyPageInvoiceDetails />}
            />
            <Route path="/pricelabels" element={<MyPagesPriceLabels />} />
            <Route
              path="/service"
              element={<MyPagesService {...props} />}
            />
            <Route path="/rma" element={<MyPagesRma />} />
            <Route
              path="/orderapprover"
              element={<MyPagesOrderApprover />}
            />
            <Route
              path="/orderapprover/:id/:nav"
              element={<MyPagesOrderDetail />}
            />

            {userInfo?.isBusinessCustomer && (
              <>
                <Route path="/users" element={<MyPagesUsers />} />
                <Route path="/users/add" element={<MyPagesAddUser />} />
                <Route
                  path="/users/edit/:id"
                  element={<MyPagesEditUser />}
                />
                <Route
                  path="/imagestorage"
                  element={<MyPagesImageStorage  imageStoragePageUrl={props?.imageStoragePageUrl}/>}
                />      
                <Route path="/addresses" element={<MyPagesAddresses />} />
                <Route
                  path="/addresses/add"
                  element={<MyPagesAddAddress />}
                />
                <Route
                  path="/addresses/edit/:id"
                  element={<MyPagesEditAddress />}
                />
              </>
            )}
          </Routes>
        </HashRouter>
        <div id="price-labels-container" className="col-span-full"></div>
      </section>
    </>
  );
};

export default MyPagesContainer;
